//@ts-ignore
import React, { FC } from 'react';
import { CloseButtonStyled } from './styled';
import { ButtonProps } from './types';

export const CloseButton: FC<ButtonProps & { children?: any }> = ({ onClick, isFullscreen }) => (
  <CloseButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
    <i className="fas fa-times" />
  </CloseButtonStyled>
);
